import React from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import CustomScrollView from 'src/components/10-atoms/list-views/CustomScrollView';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import styleUtils from 'src/utils/styles';
import EmptyTabsList from './EmptyTabsList';
import TabItem from './TabItem';
const TabsList = ({ tabs, editable = true, activeTabID, onTabChange, onAddTab, onEditTab, onDeleteTab, onViewHistory, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    return (React.createElement(CustomScrollView, { containerStyle: styleUtils.flex },
        React.createElement(Column, { flex: true, pv: theme.spacing.standard.sm }, tabs.length === 0 ? (React.createElement(EmptyTabsList, { editable: editable, onAddTab: onAddTab })) : tabs.map((tab) => (React.createElement(TabItem, { key: tab.id, tab: tab, isActive: activeTabID === tab.id, editable: editable, onTabChange: onTabChange, onEditTab: onEditTab, onDeleteTab: onDeleteTab, onViewHistory: onViewHistory }))))));
};
const stylesGenerator = createThemedStyle(() => ({}));
export default TabsList;
